import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { WireProduct } from 'scenes/common/api/quote/types';
import { HeaderTop } from 'scenes/common/components/Header';
import YouAreCovered from 'scenes/common/components/Header/YouAreCovered';
import { Building } from 'scenes/home/components/Header/Building';
import { HomeForRent } from 'scenes/landlord/components/Header/HomeForRent';
import { Car } from 'scenes/motor/components/Header/Car';
import { getPaymentState } from 'scenes/payments/redux/payment/selectors';
import { isConfirmationPage } from 'scenes/payments/routes';

const getConfirmationImage = (product: WireProduct): FunctionComponent => {
  switch (product) {
    case WireProduct.Motor:
      return () => <Car />;
    case WireProduct.Home:
      return () => <Building />;
    case WireProduct.Landlord:
    default:
      return () => <HomeForRent />;
  }
};

const Header: FunctionComponent = () => {
  const paymentState = useSelector(getPaymentState);
  const location = useLocation();
  return (
    <>
      <HeaderTop
        progress={0}
        showProgressBar={false}
        onClickCallUs={() => {}}
      />
      {isConfirmationPage(location.pathname) && (
        <YouAreCovered
          Image={getConfirmationImage(paymentState.product)}
          payment
        />
      )}
    </>
  );
};
export default Header;
